import * as React from 'react';
import { FunctionComponent, PropsWithChildren } from 'react';

import { FormControl } from '@mui/material';

import BaseFormInputField from '../../../../../shared/components/base-input-form-field/base-form-input-field';
import { ExceptedAppsReleaseFormProps } from '../types/excepted-apps-release-form-props.type';

export const VersionCodeInput: FunctionComponent<
  ExceptedAppsReleaseFormProps
> = (props: PropsWithChildren<ExceptedAppsReleaseFormProps>) => {
  const { values, errors, touched, handleChange, handleBlur } = props;

  return (
    <FormControl>
      <BaseFormInputField
        id="version-code"
        label="Version Code"
        name="versionCode"
        onBlur={handleBlur}
        onChange={handleChange}
        error={!!errors.versionCode && touched.versionCode}
        helperText={
          !!errors.versionCode && touched.versionCode && errors.versionCode
        }
        value={values?.versionCode ?? ''}
        InputLabelProps={{ required: true }}
      />
    </FormControl>
  );
};
